import { Module } from 'vuex';

import { RootState } from 'frontend/types';

interface NextSubscriptionPaymentState {
  amount: string;
  next_billing_date: string;
}

const nextSubscriptionPayment: Module<NextSubscriptionPaymentState, RootState> = {
  namespaced: true,
  state: {} as NextSubscriptionPaymentState,
  mutations: {
    setValue(state: NextSubscriptionPaymentState, value: NextSubscriptionPaymentState): void {
      Object.assign(state, value);
    },
  },
  getters: {
    nextBillingDate(state): string {
      return state.next_billing_date;
    },
  },
};

export default nextSubscriptionPayment;
